import {useEffect, useRef} from 'react';
import {getCookie} from '../../authUtils';

export default function FlowiseChat() {
    const initializedRef = useRef(false);
    const MAX_WAIT_MS = 30_000;
    const STEP_MS = 300;

    const adminBaseUrl = process.env.REACT_APP_ADMIN_BASE_URL;

    useEffect(() => {
        let cancelled = false;

        const init = async (userId, userName, userEmail) => {
            if (initializedRef.current || cancelled) {
                return;
            }

            const GIT_COMMIT_SHA = process.env.REACT_APP_FLOWISE_EMBED_GIT_COMMIT_SHA;
            const cacheBust = Date.now();

            const { default: Chatbot } = await import(
                /* webpackIgnore: true */
                /* @vite-ignore */
                `https://cdn.jsdelivr.net/gh/Fraktalwerk/FlowiseChatEmbed@${GIT_COMMIT_SHA}/dist/web.js?module&adminBaseUrl=${encodeURIComponent(adminBaseUrl)}&v=${cacheBust}`
                );

            const sessionId = userId;

            Chatbot.init({
                chatflowid: process.env.REACT_APP_FLOWISE_CHATFLOW_ID,
                apiHost: process.env.REACT_APP_FLOWISE_API_HOST,
                chatflowConfig: {
                    returnSourceDocuments: true,
                    // sessionId,
                    // vars: {
                    //     userId,
                    //     userName,
                    //     userEmail,
                    //     sessionId
                    // },
                },
                theme: {
                    button: {
                        backgroundColor: '#0d1d95',
                        right: 20,
                        bottom: 20,
                        size: 48,
                        dragAndDrop: true,
                        iconColor: 'white',
                        autoWindowOpen: {
                            autoOpen: false,
                            openDelay: 2,
                            autoOpenOnMobile: false
                        },
                    },
                    chatWindow: {
                        backgroundColor: '#f3f5f9',
                        height: 700,
                        width: 400,
                        title: 'Fraktalwerk AI Bot',
                        showTitle: true,
                        renderHTML: true,
                        welcomeMessage:
                            "Hello! 👋 <br />I’m here to help you find information about processes, documents and policies. <br />What would you like to know today?",
                        botMessage: {
                            backgroundColor: '#1828b4f2',
                            textColor: '#fff',
                            showAvatar: true,
                            avatarSrc: 'https://cdn.fraktalwerk.dev/assets/fw_logo.png'
                        },
                        userMessage: {
                            backgroundColor: '#fff',
                            textColor: '#0d1d95',
                            showAvatar: true,
                            avatarSrc: 'https://cdn.fraktalwerk.dev/assets/avatar.png'
                        },
                        textInput: {
                            sendButtonColor: '#0d1d95',
                        },
                        footer: {
                            textColor: 'grey',
                            text: 'This is a beta product, this chat can make mistakes, always check provided sources.',
                            company: '',
                            companyLink: ''
                        },
                        dateTimeToggle: {
                            date: true,
                            time: true
                        },
                        sourceDocsTitle: 'Sources: ',
                        customCSS: `
                        .chatbot-guest-bubble { border: 1px solid lightgray !important; }
                        .footer-disclaimer { font-size: 11px !important; }
                        `,
                    },
                },
            });

            initializedRef.current = true;
        };

        const waitForCookie = (deadline) => {
            if (cancelled || initializedRef.current) {
                return;
            }

            const userId = getCookie('USER_ID');
            const userName = getCookie('USER_NAME');
            const userEmail = getCookie('USER_EMAIL');

            if (userId) {
                void init(userId, userName, userEmail);
            } else if (Date.now() < deadline) {
                setTimeout(() => waitForCookie(deadline), STEP_MS);
            }
            // else: give up silently (not logged in)
        };

        waitForCookie(Date.now() + MAX_WAIT_MS);

        return () => {
            cancelled = true;
        };
    }, []);

    return null;
}